import { AnimatePresence, motion } from "framer-motion";
import { useEffect, useState } from "react";

export const ThankYouModal = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const show = () => setOpen(true);
    window.addEventListener("mik-joined", show);
    return () => window.removeEventListener("mik-joined", show);
  }, []);

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          data-testid="thank-you-modal"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 px-5 backdrop-blur-sm"
          onClick={() => setOpen(false)}
        >
          <motion.div
            initial={{ opacity: 0, y: 24, scale: 0.96 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 12, scale: 0.96 }}
            transition={{ type: "spring", stiffness: 320, damping: 26 }}
            onClick={(e) => e.stopPropagation()}
            className="w-full max-w-sm rounded-3xl border border-[#0f93cc]/25 bg-[#0c0d10] p-7 text-center shadow-2xl"
          >
            <div className="font-display text-3xl">🎉</div>
            <h3 className="font-display mt-3 text-xl font-bold text-white">You&rsquo;re In!</h3>
            <p className="mt-3 text-sm leading-relaxed text-white/60">
              You&rsquo;re now part of the MIK First Access community. Hang tight till{" "}
              <span className="text-[#5bc4ee]">1st September</span> — that&rsquo;s when we
              launch the biggest offer of the year.
            </p>
            <button
              data-testid="thank-you-modal-close"
              onClick={() => setOpen(false)}
              className="mt-6 w-full rounded-full bg-[#25D366] px-6 py-3 font-display text-sm font-bold uppercase tracking-wide text-[#08290f]"
            >
              Got it
            </button>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
